export const MOBILE_BREAKPOINT = 640;

const mappingLowMediumHigh: Record<string, number> = {
  low: 1,
  medium: 2,
  high: 3,
};

const mappingFailPass: Record<string, number> = {
  fail: 1,
  pass: 3,
};

function getNumericScore(score: string, criteria: string[]): number {
  if (!score || !criteria || criteria?.length === 0) return 0;
  const lowerScore = score.toLowerCase();

  if (criteria.some((c) => ["low", "medium", "high"].includes(c.toLowerCase()))) {
    return mappingLowMediumHigh[lowerScore] ?? 0;
  }

  if (criteria.some((c) => ["fail", "pass"].includes(c.toLowerCase()))) {
    return mappingFailPass[lowerScore] ?? 0;
  }

  return 0;
}

export function calculatePercentageScore(data: any[]): string {
  if (!data || data.length === 0) return "0%";
  let totalScore = 0;
  let maxScore = 0;

  data.forEach((item) => {
    const numeric = getNumericScore(item.score, item.scoring_criteria);
    totalScore += numeric;
    maxScore += 3; // max value always 3
  });

  const percentage = (totalScore / maxScore) * 100;

  return `${percentage.toFixed(0)}%`;
}

export const PAYMENT_STATUS = {
  all_good: "",
  first_time_failed: "Your last payment attempt failed — please go to billing to complete it to avoid interruptions.",
  second_time_failed: "Your subscription is overdue. Go to billing to complete your payment to restore full access.",
};
